import { createRng, randomSeed } from "./rng";
import type { AnswerPreference, LevelId, Question, Tier, TopicDef } from "./types";

const topics = new Map<string, TopicDef>();

export function registerTopics(defs: readonly TopicDef[]): void {
  for (const def of defs) {
    if (topics.has(def.id)) throw new Error(`Topic already registered: ${def.id}`);
    topics.set(def.id, def);
  }
}

export function getTopic(id: string): TopicDef {
  const def = topics.get(id);
  if (!def) throw new Error(`Unknown topic: ${id}`);
  return def;
}

export function hasTopic(id: string): boolean {
  return topics.has(id);
}

export function allTopics(): TopicDef[] {
  return [...topics.values()];
}

export function topicsForLevel(level: LevelId): TopicDef[] {
  return allTopics().filter((t) => t.level === level);
}

/** Younger levels answer with buttons by default; from klasa 5 the player types the answer. */
export function defaultPreference(level: LevelId): AnswerPreference {
  return ["sp1", "sp2", "sp3", "sp4"].includes(level) ? "choice" : "typed";
}

export function generateQuestion(
  topicId: string,
  tier: Tier,
  seed: number = randomSeed(),
  preference: AnswerPreference = "auto",
): Question {
  const def = getTopic(topicId);
  const rng = createRng(seed);
  const draft = def.generate(rng, tier);
  const pref = preference === "auto" ? defaultPreference(def.level) : preference;
  const answer = pref === "choice" && draft.choice4 ? draft.choice4 : draft.answer;
  return { ...draft, answer, id: `${topicId}:${tier}:${seed}`, topicId, tier, seed };
}
